/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M21.892 17.294l5.855 2.51a2.004 2.004 0 011.198 2.08A7.009 7.009 0 0122 28c-9.925 0-18-8.075-18-18a7.009 7.009 0 016.115-6.944 2.003 2.003 0 012.082 1.197l2.511 5.86a1.996 1.996 0 01-.165 1.883l-2.08 3.178a9.567 9.567 0 004.401 4.381l3.13-2.087a1.993 1.993 0 011.898-.174z" _fill="#0B2C62"/>'
  }
})
